module.exports = __webpack_public_path__ + "img/mural-20220724.77a0a481.jpg";